import React from "react";
import { Card, styled } from "@mui/material";
import { Grid } from "@mui/material";
import {
  ControlledSwitch,
  ControlledTextField,
  PercentTextField,
} from "../../../components/inputs";

const StyledCard = styled(Card)`
  height: auto;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 15px;
  background-color: #415781ff;

  @media (max-width: 900px) {
    height: auto;
  }

  & .MuiGrid-container {
    align-items: center;
    height: auto;
  }
`;

const StyledGrid = styled(Grid)`
  padding: 5px;
  place-self: flex-start;
`;

const StyledGridContainer = styled(Grid)`
  margin-bottom: 0px;
`;

const StyledH2 = styled("p")`
  font-family: ${({ theme }) => theme.fonts.family.title};
  color: ${({ theme }) => theme.colors.white};
  text-align: left;
  letter-spacing: 1.8px;
  font-size: 28px;
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 5px;

  @media (max-width: 900px) {
    letter-spacing: 1.6px;
    font-size: 16px;
  }
`;

const CardRegras = ({ formProps, disabled }) => {
  return (
    <StyledCard>
      <StyledH2>Sinistro</StyledH2>
      <StyledGridContainer container>
        <StyledGrid item xs={12} md={4}>
          <ControlledSwitch
            formProps={formProps}
            name="flagCalculaSinistralidade"
            label="Calcula Sinistralidade?"
            disabled={disabled}
          />
        </StyledGrid>
        <StyledGrid item xs={12} md={4}>
          <ControlledTextField
            formProps={formProps}
            fullWidth
            name="breakeven"
            label="Breakeven"
            InputProps={{
              inputComponent: PercentTextField,
            }}
          />
        </StyledGrid>
      </StyledGridContainer>
    </StyledCard>
  );
};

export default CardRegras;
